module.exports = __webpack_public_path__ + "img/Irene Sun.5855e5ab.jpg";